module.exports = __webpack_public_path__ + "img/4.ec8d544f.png";